import { EventTracking, EventType } from '@app/tracking';
export default class PinterestTag {
    constructor(tagId, scriptPath = 'https://s.pinimg.com/ct/core.js') {
        window.pintrk = function () {
            window.pintrk.queue.push(Array.prototype.slice.call(arguments));
        };
        let n = window.pintrk;
        n.queue = [], n.version = "3.0";
        let scriptTag = document.createElement('script');
        scriptTag.async = true;
        scriptTag.src = scriptPath;
        document.body.appendChild(scriptTag);
        pintrk('load', tagId);
        pintrk('page');
        if (window.laravelDebug) {
            console.log(`✅ Pinterest Tag Tracking initialized for "${tagId}"`);
        }
        this.registerListeners();
    }
    registerListeners() {
        // Page view
        EventTracking.listen(EventType.PageView, ({ title, path }) => {
            pintrk('track', 'pagevisit');
        });
        // Form success
        EventTracking.listen(EventType.FormSuccess, ({ form }) => {
            pintrk('track', 'lead', {
                lead_type: form
            });
        });
        // Locator search
        EventTracking.listen(EventType.LocatorSearch, ({ searchQuery }) => {
            pintrk('track', 'search', {
                search_query: searchQuery
            });
        });
        // Shop Add Item
        EventTracking.listen(EventType.EcommerceAddItem, event => {
            pintrk('track', 'AddToCart', {
                value: event.price,
                currency: event.currency,
                order_quantity: event.quantity
            });
        });
        // Custom events
        EventTracking.listen(EventType.Track, ({ category, action, label, value = '' }) => {
            if (category == 'E-Mail' || category == 'Phone') {
                pintrk('track', 'lead', {
                    lead_type: category
                });
            }
            else {
                pintrk('track', 'custom', {
                    category,
                    action,
                    label,
                    value
                });
            }
        });
    }
}
